<span class="reloj">
  <span class="reloj__date">{{ fecha }}</span>
  <span class="reloj__time">{{ hora }}:{{ minutos }}:{{ segundos }}</span>
</span>
